export default __webpack_public_path__ + "static/media/Group462.552883b4.svg";